__turbopack_context__.v({
  "animate_underline": "Layout-module-scss-module__tDEdYq__animate_underline",
  "app-side-padding": "Layout-module-scss-module__tDEdYq__app-side-padding",
  "apply-possible-content-wrapper": "Layout-module-scss-module__tDEdYq__apply-possible-content-wrapper",
  "balloon-refund-animate-border-bottom-color": "Layout-module-scss-module__tDEdYq__balloon-refund-animate-border-bottom-color",
  "balloon-refund-animate-color": "Layout-module-scss-module__tDEdYq__balloon-refund-animate-color",
  "balloon_refund": "Layout-module-scss-module__tDEdYq__balloon_refund",
  "blur": "Layout-module-scss-module__tDEdYq__blur",
  "blur--after": "Layout-module-scss-module__tDEdYq__blur--after",
  "blur--before": "Layout-module-scss-module__tDEdYq__blur--before",
  "bznav-main": "Layout-module-scss-module__tDEdYq__bznav-main",
  "divider": "Layout-module-scss-module__tDEdYq__divider",
  "fullcare-main": "Layout-module-scss-module__tDEdYq__fullcare-main",
  "fullcare-sub": "Layout-module-scss-module__tDEdYq__fullcare-sub",
  "heading-1": "Layout-module-scss-module__tDEdYq__heading-1",
  "heading-2": "Layout-module-scss-module__tDEdYq__heading-2",
  "heading-3": "Layout-module-scss-module__tDEdYq__heading-3",
  "heading-4": "Layout-module-scss-module__tDEdYq__heading-4",
  "heading-5": "Layout-module-scss-module__tDEdYq__heading-5",
  "heading-6": "Layout-module-scss-module__tDEdYq__heading-6",
  "heading-7": "Layout-module-scss-module__tDEdYq__heading-7",
  "heading-8": "Layout-module-scss-module__tDEdYq__heading-8",
  "highlight-gradient": "Layout-module-scss-module__tDEdYq__highlight-gradient",
  "lookup-result-layout": "Layout-module-scss-module__tDEdYq__lookup-result-layout",
  "main_top_margin": "Layout-module-scss-module__tDEdYq__main_top_margin",
  "notice-container": "Layout-module-scss-module__tDEdYq__notice-container",
  "paragraph-0": "Layout-module-scss-module__tDEdYq__paragraph-0",
  "paragraph-1": "Layout-module-scss-module__tDEdYq__paragraph-1",
  "paragraph-2": "Layout-module-scss-module__tDEdYq__paragraph-2",
  "paragraph-3": "Layout-module-scss-module__tDEdYq__paragraph-3",
  "paragraph-4": "Layout-module-scss-module__tDEdYq__paragraph-4",
  "paragraph-5": "Layout-module-scss-module__tDEdYq__paragraph-5",
  "paragraph-6": "Layout-module-scss-module__tDEdYq__paragraph-6",
  "paragraph-7": "Layout-module-scss-module__tDEdYq__paragraph-7",
  "paragraph-8": "Layout-module-scss-module__tDEdYq__paragraph-8",
  "refund-hero": "Layout-module-scss-module__tDEdYq__refund-hero",
  "refund-investor": "Layout-module-scss-module__tDEdYq__refund-investor",
  "refund-main": "Layout-module-scss-module__tDEdYq__refund-main",
  "refund-sub": "Layout-module-scss-module__tDEdYq__refund-sub",
  "shimmer": "Layout-module-scss-module__tDEdYq__shimmer",
  "trace-in": "Layout-module-scss-module__tDEdYq__trace-in",
  "trace-out": "Layout-module-scss-module__tDEdYq__trace-out",
});
